import Swal, { SweetAlertCustomClass, SweetAlertIcon } from 'sweetalert2';
import i18n from '../i18n';
import uiSettings from '../settings/ui';
import SentryClient from '@/helpers/sentry';

export interface ErrorMessageOptions {
  title?: string;
  error: any;
  customIcon?: SweetAlertIcon;
  customMessage?: string;
  defaultMessage?: boolean;
  callback?: () => void;
  dontShowMessage?: boolean;
  messageType?: 'toast' | 'alert';
  timer?: number;
  suppressErrorOnConsole?: boolean;
  customBackground?: string;
  showCancelButton?: boolean;
  customClass?: SweetAlertCustomClass;
  width?: number;
}

export class ErrorHandler {
  static showErrorMessage(options: ErrorMessageOptions): void {
    const {
      error,
      customIcon,
      customMessage,
      defaultMessage,
      callback,
      dontShowMessage,
      messageType,
      title,
      timer = 3000,
      suppressErrorOnConsole,
      customBackground,
      showCancelButton,
      customClass,
      width,
    } = options;

    // The error message will be suppressed if it was thrown while running Jest tests,
    // because there are some tests that throw an error to check it, and see an error
    // message on console during the tests can cause some confusion.
    if (!process && !suppressErrorOnConsole) {
      // eslint-disable-next-line no-console
      console.error(error);
    }

    if (dontShowMessage) return;

    const text = customMessage || error.message || i18n.t('defaultErrorMessage');
    const isAlert = messageType === 'alert';

    SentryClient.captureError(error);

    Swal.fire({
      title,
      text: defaultMessage ? i18n.t('defaultErrorMessage') : text,
      icon: customIcon || undefined,
      toast: !isAlert,
      position: !isAlert ? 'bottom-right' : undefined,
      showConfirmButton: false,
      showCancelButton: showCancelButton ?? true,
      showCloseButton: true,
      cancelButtonText: 'Fechar',
      timer,
      timerProgressBar: !!timer,
      background: customBackground || uiSettings.colorPalette.red,
      customClass,
      buttonsStyling: !customClass,
      width,
    });

    if (callback) callback();
  }
}
